var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waba-supsis-volume-based-pricing-tier-update" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "Whatsapp Business API V2 hacim bazlı fiyatlandırma seviyesi güncellendi"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "meta" }, [
        _c("div", [
          _c("b", [_vm._v("Event")]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.event"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Kanal ID")]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Tier")]),
          _vm._v(
            ": " +
              _vm._s(_vm.$_.get(_vm.activity, "payload.volume_tier_info.tier"))
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Fiyatlandırma Kategorisi")]),
          _vm._v(
            ": " +
              _vm._s(
                _vm.$_.get(
                  _vm.activity,
                  "payload.volume_tier_info.pricing_category"
                )
              )
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Geçerli Ay")]),
          _vm._v(
            ": " +
              _vm._s(
                _vm.$_.get(
                  _vm.activity,
                  "payload.volume_tier_info.effective_month"
                )
              )
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Bölge")]),
          _vm._v(
            ": " +
              _vm._s(
                _vm.$_.get(_vm.activity, "payload.volume_tier_info.region")
              )
          ),
        ]),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.volume_tier_info.tier_update_time")
          ? _c("div", [
              _c("b", [_vm._v("Güncelleme Zamanı")]),
              _vm._v(
                ": " +
                  _vm._s(
                    _vm.formatTime(
                      _vm.$_.get(
                        _vm.activity,
                        "payload.volume_tier_info.tier_update_time"
                      )
                    )
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("details", { staticClass: "raw" }, [
        _c("summary", [_vm._v("Ham payload")]),
        _vm._v(" "),
        _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }